import { css } from '@linaria/core';
import { theming } from 'styles/utils';
export const copyIconStyles = "omponents__CopyButton__CopyButton_styles_tsx-copyIconStyles-cs506he";

require("./CopyButton.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./CopyButton.styles.tsx");